<template>
    <SubscriptionForm :subscription="subscription" v-if="loaded==true" :readOnly="false" />
</template>

<script>
import {BModal, BButton, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import SubscriptionForm from './SubscriptionForm.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    SubscriptionForm
  },
  data() {
    return {
      subscription:null,
      loaded:false,
    }
  },
  methods:{
    
  },
  async mounted()
  {
     this.subscription=await APIRequest.detail('subscription-types',this.$route.params.id)
     this.loaded=true
  }
}
</script>
